export default class FinancialTarget {
    constructor () {
        this.id = null
        this.financial_year_start = null
        this.financial_year_end = null
        this.revenue = 0
        this.profit = 0
        this.sales = 0
    }
}